import { Box, Text } from '@factorialco/deprecated-design-system'

import MinutesToText from 'modules/attendance/components/MinutesToText'
import { BankOfHoursMovementContribution } from 'modules/attendance/lib/utils/BankOfHoursUtils'

type Props = {
  contributions: BankOfHoursMovementContribution[]
}

const Content = ({ contributions }: Props) => {
  return (
    <Box padding="s16" justifyContent="spaceBetween" gap="s6" background="grey100">
      {contributions.map((contribution, index) => (
        <Box key={index} flexDirection="row" justifyContent="spaceBetween">
          <Box flexDirection="column">
            <Text.Normal size="200" color="textPrimary">
              {contribution.text}
            </Text.Normal>
            <Text.Normal size="100" color="textSecondary">
              {contribution.subtext}
            </Text.Normal>
          </Box>

          <Box flexDirection="row" paddingRight="s32">
            <MinutesToText
              value={contribution.minutes}
              size="200"
              weight="medium"
              color="grey1000"
              whiteSpace="nowrap"
            ></MinutesToText>
          </Box>
        </Box>
      ))}
    </Box>
  )
}

export default Content
